<template>
    <CompassSelect
        v-if="!loading"
        v-model="currency"
        filterable
        :error="error"
        @update:model-value="updateCurrency"
    >
        <CompassDropdownOption
            v-for="option in sortedCurrencies"
            :key="option.id"
            :label="option[mode]"
            :value="option.name"
        />
    </CompassSelect>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('system');

export default {
    props: {
        mode: {
            type: String,
            required: false,
            default: 'longname',
            validator: function (value) {
                return ['longname', 'symbol'].includes(value);
            },
        },
        modelValue: {
            type: String,
            required: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            loading: false,
            topsCurrencies: ['EUR', 'USD', 'YEN', 'GBP'],
            currency: this.modelValue,
        };
    },
    computed: {
        ...mapState({
            allCurrencies: 'currencies',
        }),
        sortedCurrencies() {
            const sorted = [...this.allCurrencies].sort((a, b) =>
                a.longname.localeCompare(b.longname),
            );

            const tops = [];
            const others = [];
            for (const currency of sorted) {
                if (this.topsCurrencies.includes(currency.name)) {
                    tops.push(currency);
                } else {
                    others.push(currency);
                }
            }

            return [...tops, ...others];
        },
    },
    created() {
        if (this.modelValue) {
            const found = this.allCurrencies.find((currency) => currency.name === this.modelValue);
            if (!found) {
                this.currency = this.topsCurrencies[0];
                this.updateCurrency();
            }
        }
    },
    methods: {
        updateCurrency() {
            this.$emit(
                'update:modelValue',
                this.allCurrencies.find((currency) => currency.name === this.currency),
            );
        },
    },
};
</script>
